import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { theme, transformBoxShadowToDropShadow, } from "@pluxee-design-system/core";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(["container", "chart", "legend", "tooltip"]);
const baseStyle = definePartsStyle({
    container: {
        height: "100%",
        maxHeight: "100%",
        display: "flex",
        flexDirection: "column",
        rowGap: "1rem",
        padding: "1rem 1.5rem",
        bg: "semantic.surface.1",
    },
    chart: {
        flex: 1,
        minHeight: 0,
        height: "100%",
    },
    legend: {
        height: "24px",
        maxHeight: "24px",
        overflow: "hidden",
    },
    tooltip: Object.assign(Object.assign({ display: "none", position: "absolute", color: "semantic.text.inverse", backgroundColor: "semantic.foreground.primary", padding: "8px 16px 2px", borderRadius: 0 }, theme.textStyles.title.mobileSection), { filter: `drop-shadow(${transformBoxShadowToDropShadow(theme.shadows.large)})`, _after: {
            content: '""',
            position: "absolute",
            top: "100%",
            left: "calc(50% + var(--tooltip-adjusted-left))",
            transform: "translateX(-50%)",
            borderTop: `16px solid ${theme.colors.semantic.foreground.primary}`,
            borderRight: "16px solid transparent",
            borderLeft: "16px solid transparent",
            borderBottom: "0px solid transparent",
        } }),
});
const BarChartTheme = defineMultiStyleConfig({
    baseStyle,
});
export default BarChartTheme;
//# sourceMappingURL=BarChart.default.js.map